export default __webpack_public_path__ + "static/media/franceh.d9bbbfac.webp";